import { Grid, Typography } from '@mui/material';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import { SarlaftInsuranceProps } from './props';
import { useSarlaftInsurance } from './hook';

export const SarlaftInsurance = (props: SarlaftInsuranceProps) => {
    const { formik } = useSarlaftInsurance(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información sobre reclamaciones de seguros
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Checkbox
                    label="¿Ha presentado reclamaciones o ha recibido indemnizaciones en seguros en los dos últimos años?"
                    checked={Boolean(formik.values.complaintsLastTwoYears)}
                    onChange={() => {
                        formik.setFieldValue(
                            'complaintsLastTwoYears',
                            !formik.values.complaintsLastTwoYears
                        );
                    }}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.complaintsLastTwoYears}
                />
            </Grid>
        </Grid>
    );
};
